import React, { FunctionComponent } from 'react'

export interface AuctionDetailDrawerFooterWrapperProps {
  isAssignmentMode: boolean
  isAssignmentReady?: boolean
  isAlreadyAssigned?: boolean
  children: React.ReactNode
}

export const AuctionDetailDrawerFooterWrapper: FunctionComponent<AuctionDetailDrawerFooterWrapperProps> =
  ({ isAssignmentMode, isAssignmentReady, isAlreadyAssigned, children }) => {
    return (
      <div
        className={`relative w-full ${
          isAssignmentMode ? 'h-40' : 'h-12'
        } transition-all duration-300 ease-in-out`}
      >
        {isAssignmentMode && (
          <div
            className={`absolute inset-0 rounded ${
              isAssignmentReady
                ? isAlreadyAssigned
                  ? 'bg-gray-100'
                  : 'bg-lime-50'
                : 'bg-primaryHover/20 animate-pulse'
            }`}
          />
        )}
        <div
          className={`flex items-center justify-center w-full h-full relative z-10 ${
            isAssignmentMode ? 'flex-col' : ''
          }`}
        >
          {children}
        </div>
      </div>
    )
  }
